import React, { useState, useEffect, useCallback } from 'react';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import { getToken, getMe, logout as apiLogout } from './services/api';

function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const handleLogout = useCallback(() => {
    apiLogout();
    setUser(null);
  }, []);

  // Valida o token existente ao montar (e reage a 401 global).
  useEffect(() => {
    let active = true;

    const validate = async () => {
      if (!getToken()) {
        if (active) { setUser(null); setChecking(false); }
        return;
      }
      try {
        const me = await getMe();
        if (active) setUser(me);
      } catch (err) {
        if (active) setUser(null);
      } finally {
        if (active) setChecking(false);
      }
    };

    validate();

    const onUnauthorized = () => handleLogout();
    window.addEventListener('r360-unauthorized', onUnauthorized);
    return () => {
      active = false;
      window.removeEventListener('r360-unauthorized', onUnauthorized);
    };
  }, [handleLogout]);

  if (checking) {
    return <div className="loading">Carregando...</div>;
  }

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  return <Dashboard user={user} onLogout={handleLogout} />;
}

export default App;
